jQuery( function ($) {

  if ( typeof gform != 'object' ) { return }

  // improved gform ajax spinner
  $(document).on( 'submit', '.gform_wrapper form', function () {
    let $button = $( 'button[type=submit]', this )
    if ( !$button.length ) { return }
    $button.attr( 'disabled', true )
    $button.attr( 'aria-disabled', 'true' )
    $button.addClass( 'is-ajax-submitting' )
  })


  $(document).on( 'gform_post_render', function ( e, form_id, current_page ) {
    const $form = $( `#gform_${ form_id }` )
    const $confirmation = $( `#gform_confirmation_wrapper_${ form_id }` )

    // reinit select2
    $( 'select', $form ).each( function () {
      ThemeJS.Functions.init_select2( this )
    })

    // recalc wrapping slider height
    const $slider = ( $form.length ? $form : $confirmation ).closest( '.slick-slider' )
    if ( $slider.length ) {
      $slider.slick( 'setPosition' )
      if ( $confirmation.length ) {
        ThemeJS.Functions.scroll_to( $confirmation, { direction: 'up' });
      }
    }

    // scroll up to first error field
    const $first_err = $( '.gfield_error', $form ).filter(':visible').first()
    if ( $first_err.length ) {
      ThemeJS.Functions.scroll_to( $first_err, { direction: 'up' } )
    }    
  })

  $(document).on( 'gform_page_loaded', function ( e, form_id, current_page ) {
    ThemeJS.Functions.scroll_to( $(`#gform_wrapper_${ form_id }`), {
      direction: 'up',
    });
  })

})